export enum ResilienceMechanism {
	INDEXEDDB = 'indexeddb',
	MEMORY = 'memory',
}

export interface BatchableQueue<T> {
	addItem(item: T): Promise<void>;
	getGlobalRetryCount(): number;
	start(flushCallback: BatchFlushCallback<T>): void;

	stop(): void;
}

export type StrictRetryQueueOptions = {
	backoffFactor: number;
	backoffJitterPercentage: number;
	batchFlushSize: number;

	// To be deprecated for `flushWaitMs`
	flushBeforeUnload: boolean;

	flushWaitMs: number;
	maxAttempts: number;
	// The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
	maxQueueSize: number;
	maxRetryDelay: number;
	minRetryDelay: number;
};

export type RetryQueueOptions = Partial<StrictRetryQueueOptions>;

export type Callback = (error: any, response: any) => void;

export type BatchFlushCallback<T> = (items: T[], callback: Callback) => Promise<void>;

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export enum NetworkStatusEnum {
	ONLINE,
	OFFLINE,
}

export type NetworkStatusChangeCallback = (state: NetworkStatusEnum) => void;
